import React from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSortBy: string;
  currentSortOrder: 'ASC' | 'DESC';
  onSort: (sortBy: string, sortOrder: 'ASC' | 'DESC') => void;
  className?: string;
  children?: React.ReactNode;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  label,
  sortKey,
  currentSortBy,
  currentSortOrder,
  onSort,
  className = '',
  children
}) => {
  const isActive = currentSortBy === sortKey;
  
  const handleSort = () => {
    if (isActive) {
      // If already sorting by this column, toggle the order
      const newOrder = currentSortOrder === 'ASC' ? 'DESC' : 'ASC';
      onSort(sortKey, newOrder);
    } else {
      // If not sorting by this column, start with DESC
      onSort(sortKey, 'DESC');
    }
  };

  return (
    <th 
      className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors duration-150 select-none group ${className}`}
      onClick={handleSort}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {children || label}
        </div>
        <div className="flex flex-col ml-1">
          {/* Up arrow */}
          <ChevronUpIcon 
            className={`h-3 w-3 transition-colors duration-150 ${
              isActive && currentSortOrder === 'ASC' 
                ? 'text-blue-600' 
                : 'text-gray-300 group-hover:text-gray-500'
            }`}
          />
          {/* Down arrow */}
          <ChevronDownIcon 
            className={`h-3 w-3 -mt-1 transition-colors duration-150 ${
              isActive && currentSortOrder === 'DESC' 
                ? 'text-blue-600' 
                : 'text-gray-300 group-hover:text-gray-500'
            }`}
          />
        </div>
      </div>
    </th>
  );
};

export default SortableTableHeader; 